import React from 'react';
import { Sparkles, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import BoltBadge from './BoltBadge';

const Footer: React.FC = () => {
  return (
    <footer className="py-8 bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border-t border-slate-200/50 dark:border-slate-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-3 mb-4 md:mb-0">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center animate-float">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold text-slate-800 dark:text-slate-200">
              RoomState
            </span>
          </div>
          
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <div className="flex gap-6">
              <Link to="/privacy" className="text-sm text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 transition-colors">
                Privacy
              </Link>
              <Link to="/terms" className="text-sm text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 transition-colors">
                Terms
              </Link>
              <a href="mailto:support@roomstate.site" className="text-sm text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 transition-colors">
                Contact
              </a>
            </div>
            
            <BoltBadge />
          </div>
        </div>
        
        <div className="mt-6 text-center text-sm text-slate-500 dark:text-slate-500">
          <p>© 2025 RoomState. All rights reserved.</p>
          <p className="mt-1 flex items-center justify-center gap-1">
            Made with <Heart className="w-3 h-3 text-red-500" /> for the Bolt.new Hackathon
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;